/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/api/product.ts
 * @Description: 商品相关接口
 */
import { fetch } from 'libs/fetch';
/** description：获取店铺评价
 *  @evaluateObjectSysNo string 商店评价系统编号
 *  @status number 商铺状态
 *  @evaluateObjectType number 商铺类型
 *  @pageSize number 评价分页大小
 *  @pageNo number 当前页码
 *   @return {{ pageNo: number; total: number; pageSize: number; totalPage: number; datas: {} }}
 */
export async function getEvaluationData(params: {
  status: number;
  evaluateObjectType: number;
  evaluateObjectSysNo: string; // 供应商店铺 supplierSysNo
  pageNo: number;
  pageSize: number;
}) {
  const res = await fetch('/api/supplier/v1/supplier/perfDynamicEvaluation/search', {
    method: 'POST',
    json: params,
  });
  return res;
}

type IMETHOD = {
  accountPeriod: string;
  agreementSysNo: string;
  supplierSysNo: string;
};

/**
 * 获取商品详情
 * @param {{
  sysNo:string,
  areaSysNo:string,
  tradeAgreementSysNo:string,
  mmuAttributeList:[],
  supplierSkuSysNo:null,
  frontDefaultTradeMethodList: Array<IMETHOD>
}} params
 * @returns {unknown}
 */
export type IProductDetailParams = {
  sysNo: string;
  areaSysNo: string;
  tradeAgreementSysNo?: string;
  supplierSkuSysNo?: string;
  mmuAttributeList?: Array<any>;
  frontDefaultTradeMethodList?: Array<IMETHOD>;
  chooseAgreement?: Array<IMETHOD>;
  netPriceType?: string;
};
export async function getProductDetail(params: IProductDetailParams) {
  const res = await fetch('/api/mall/v1/mallSku/getDetail', {
    method: 'POST',
    json: params,
  });
  return res;
}

// 商品规格查询
export type ISkuParams = {
  areaSysNo: string;
  supplierSysNo: string;
  pageNo: number;
  pageSize: number;
  model?: string;
  mallSkuSysNo: string;
  mallSkuList?: null | any[];
  categoryAttributeList: any[];
};

// 获取商品「速采清单」
export async function getProductSkuList(params: ISkuParams) {
  const res = await fetch('/api/mall/v1/mallSku/getSpuForAllSkuList', {
    method: 'POST',
    json: params,
  });
  return res;
}

// 商品浏览历史
export type historyParams = {
  supplierSkuSysNo: string;
  productName: string;
  productPrice: string;
  productImgUrl: string;
  shopMainPage: string;
};
export async function saveProductSkuInfo(params: historyParams) {
  const res = await fetch('/api/mall/v1/purchaser/browseHistory/save', {
    method: 'POST',
    json: params,
  });
  return res;
}

export default {
  getEvaluationData,
  getProductDetail,
  getProductSkuList,
  saveProductSkuInfo,
};
